export const ProgressBarCell = ({ value }: { value: number }) => {
  const percentage = Math.round(value);

  const getColor = () => {
    if (percentage < 0) return "#aaa"; // invalid
    if (percentage > 100) return "#ff4d4f"; // BAD (more than 100)
    if (percentage < 30) return "#ff4d4f"; // red
    if (percentage < 70) return "#faad14"; // yellow
    return "#52c41a"; // green
  };

  return (
    <div className="flex items-center gap-2 w-[90px]">
      <div className="w-full h-[6px] bg-gray-200 rounded">
        <div
          className="h-[6px] rounded transition-all duration-300"
          style={{
            width: `${Math.min(Math.abs(percentage), 100)}%`,
            backgroundColor: getColor(),
          }}
        />
      </div>

      <span className="text-[11px] font-semibold" style={{ color: getColor() }}>
        {percentage}%
      </span>
    </div>
  );
};
